import { forwardRef } from 'react';
import type { InputHTMLAttributes, TextareaHTMLAttributes } from 'react';
import { cn } from '../../lib/cn';

// Shared field look: inset well, subtle border, emerald focus ring. Used by both
// the single-line Input and the multi-line Textarea so they stay in lockstep.
const fieldBase =
  'w-full rounded-xl bg-black/25 border border-transparent px-3 py-2 text-sm text-fg ' +
  'placeholder:text-fg-3 transition-colors duration-pop ease-out-strong ' +
  'focus:outline-none focus:border-emerald-400/60 focus:ring-1 focus:ring-emerald-400/40 ' +
  'disabled:opacity-50';

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  function Input({ className, ...rest }, ref) {
    return <input ref={ref} className={cn(fieldBase, className)} {...rest} />;
  }
);

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaHTMLAttributes<HTMLTextAreaElement>>(
  function Textarea({ className, rows = 3, ...rest }, ref) {
    return <textarea ref={ref} rows={rows} className={cn(fieldBase, 'resize-none', className)} {...rest} />;
  }
);
